/**
 * contact-us-form web component
 *
 * @module contact-us-form
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'contact-us-form';

if (!customElements.get(customElements.component)) {

  class contactUsForm extends HTMLElement {

    /**
      * contact-us-form web component
      *
      * @constructor
      */
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.btn = this.querySelector('form button[type="button"]');
      this.inputs = this.form.querySelectorAll('input[aria-required="true"], textarea[aria-required="true"]');

      this.initEvents();
    }

    /**
    * Init component events
    *
    * @returns {undefined}
    */
    initEvents() {
      this.btn.addEventListener('click', (e) => this.handleClick(e));
      this.inputs.forEach(input => {
        input.addEventListener('click', () => {
          document.querySelectorAll('.contact__field-error').forEach((error) => {
            this.querySelectorAll('.contact .active').forEach(item => {
              item.classList.remove('active');
            });
            error.style.display = 'none';
          });
        });
      })
    }

    /**
      * Handle form submit
      *
      * @param {Event} e - The submit event
      * @returns {undefined}
      */
    handleClick(e) {
      e.preventDefault();
      let hasErrors = false;

      this.inputs.forEach((input) => {
        if (!input.value.trim()) {
          hasErrors = true;
          const text = this.querySelector(`.${input.id}`).dataset.value;
          this.showError(input, text);
        }else{
          if(input.name === 'contact[email]'){
            const emailValue = input.value.trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRegex.test(emailValue)) {
                hasErrors = true;
                const text = this.querySelector(`.${input.id}`).dataset.invalid;
                this.showError(input, text);
            }
          }
        }
      });

      if (!hasErrors) {
        //remove the active (padding class)
        this.querySelectorAll('.contact .active').forEach(item => {
          item.classList.remove('active');
        });
        this.form.submit();
      }
    }

    /**
    * Show error for a specific input
    *
    * @param {HTMLElement} input - The input element
    * @returns {undefined}
    */
    showError(input, text) {
      const errorInline = this.querySelector(`.${input.id}`);
      const content = this.querySelector(`.${input.id} .contact__field-error-text`);
      if(errorInline){
        errorInline.style.display = 'block';
      }
      this.querySelector(`.${input.id}-container`).classList.add('active');
      if(content){
        content.innerText = text;
      }
    }
  }

  customElements.define(customElements.component, contactUsForm);
}